import type { EdgeId } from '@ipfabric/utils';
import { canOpenDeviceEdgeEntity } from 'components/DeviceView/helpers/canOpenDeviceEdgeEntity';
import { getShowEdgeDetailArgs } from 'components/DeviceView/helpers/getShowEdgeDetailArgs';
import { showEdgeDetail as showDeviceViewEdgeDetail } from 'components/DeviceView/model/commands/showEdgeDetail';
import { option } from 'fp-ts';
import { pipe } from 'fp-ts/lib/pipeable';
import type { GraphCommandFactory } from '../model/GraphCommandContext';
import { selectSnapshotToCompareId } from '../model/selectors/overlay/selectSnapshotToCompareId';

export interface ShowEdgeDetailCommand {
  edgeId: EdgeId;
}

export const showEdgeDetail: GraphCommandFactory<ShowEdgeDetailCommand> =
  (cmdContext) => (command) => {
    const { graph } = cmdContext.getState();
    pipe(
      graph.edges[command.edgeId],
      option.fromNullable,
      option.map((edgeData) => {
        const sourceSn = graph.nodes[edgeData.source]?.sn ?? null;
        const targetSn = graph.nodes[edgeData.target]?.sn ?? null;

        if (
          !sourceSn ||
          !targetSn ||
          !canOpenDeviceEdgeEntity(edgeData.protocol)
        ) {
          return;
        }
        const snapshotToCompareId = selectSnapshotToCompareId(
          cmdContext.getState(),
        );
        cmdContext
          .getDeviceView()
          .dispatch(
            showDeviceViewEdgeDetail,
            getShowEdgeDetailArgs(
              command.edgeId,
              edgeData,
              graph,
              sourceSn,
              targetSn,
              snapshotToCompareId,
            ),
          );
      }),
    );
  };
